export const RETURN_LABEL_CREATED_EVENT = 'returnRequestSubmitted'
export const CANCELLATION_REQUESTED_EVENT = 'cancellationRequested'
export const CONTACT_SELLER_MESSAGE_FORM_SUBMITTED_EVENT =
  'submit_mp_seller_question'
export const RETURN_SUBMITTED_EVENT = 'submit_return'
export const CANCELLABLE_SUBMITTED_EVENT = 'submit_cancellation'
